import React, { useMemo } from 'react';
import { formatNumberToLargestUnit } from '../utils/formatters';

interface McTooltipProps {
  children: React.ReactNode;
  currentMc: number;
  athMc: number;
  className?: string;
}

const McTooltip: React.FC<McTooltipProps> = ({
  children,
  currentMc,
  athMc,
  className = ""
}) => {
  const tooltipContent = useMemo(() => (
    <div className="bg-gray-900 rounded-lg shadow-xl border border-gray-800 p-3 w-[130px] min-w-[130px]">
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-xs text-gray-400">현재 MC:</span>
          <span className="text-xs text-white font-medium">
            ${formatNumberToLargestUnit(currentMc || 0)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-xs text-gray-400">ATH MC:</span>
          <span className="text-xs text-white-400 font-medium">
            ${formatNumberToLargestUnit(athMc || 0)}
          </span>
        </div>
      </div>
    </div>
  ), [currentMc, athMc]);

  return (
    <div className={`group relative ${className}`}>
      {children}
      <div className="absolute top-full right-0 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[9999]">
        {tooltipContent}
        <div className="absolute bottom-full right-4 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-800"></div>
      </div>
    </div>
  );
};

export default McTooltip;
